module.exports = __webpack_public_path__ + "img/logo.208bf09f.png";